module.exports = __webpack_public_path__ + "dc3bc9158995be4647c0086d7efd14e0.svg";